import {connect} from 'react-redux';

import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../srcCommon/helpers/reselectHelpers';
import {buildAddInboxSettingsPath} from '../../../helpers/modelHelpers';
import {buildChannelSettingsPath} from '../../../helpers/models/channelHelpers';
import {ThunkAction} from '../../../store/appThunk';
import {getUserOwnedChannels, makeGetChannelInbox} from '../../../store/data/channels/channelsSelectors';
import {getUserNamespace} from '../../../store/data/teammates/teammatesSelectors';
import {getHasNewInboxSettingsDetails} from '../../../store/featureFlags/featureFlagsSelectors';
import {navigateToLinkAction} from '../../../store/stateless/navigationActions';
import {CalendarsEmpty} from './calendarsEmpty';

/*
 * Selectors.
 */

const getReAuthChannel = createSelector([getUserOwnedChannels], (userOwnedChannels) =>
  userOwnedChannels.find((c) => c.behaviors.isMissingCalendarScopes),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  reAuthChannel: getReAuthChannel,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onGoToReAuthChannelSettingsClick: (): ThunkAction => (dispatch, getState) => {
    const state = getState();
    const reAuthChannel = getReAuthChannel(state);
    if (!reAuthChannel) {
      return;
    }

    const getReAuthInbox = makeGetChannelInbox(() => reAuthChannel);
    const reAuthInbox = getReAuthInbox(state, {});

    if (!reAuthInbox) {
      return;
    }

    const settingsPath = buildChannelSettingsPath(
      getHasNewInboxSettingsDetails(state),
      reAuthInbox,
      reAuthChannel,
    );
    dispatch(navigateToLinkAction(settingsPath));
  },
  onAddGoogleChannelClick: (): ThunkAction => (dispatch, getState) => {
    const userNamespace = getUserNamespace(getState());
    const path = `${buildAddInboxSettingsPath(userNamespace)}?channelType=email&triggerOAuthType=google`;
    dispatch(navigateToLinkAction(path));
  },
  onAddOffice365ChannelClick: (): ThunkAction => (dispatch, getState) => {
    const userNamespace = getUserNamespace(getState());
    const path = `${buildAddInboxSettingsPath(userNamespace)}?channelType=email&triggerOAuthType=office365`;
    dispatch(navigateToLinkAction(path));
  },
}));

export const CalendarsEmptyContainer = connect(mapStateToProps, mapDispatchToProps)(CalendarsEmpty);
